"use strict";

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(a) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _formik = require("formik"),
    _antd = require("antd"),
    _immer = _interopRequireDefault(require("immer")),
    _Button = _interopRequireDefault(require("../Button")),
    _Sortable = _interopRequireDefault(require("../Sortable")),
    S = _interopRequireWildcard(require("./styles")),
    _Inputs = require("../Inputs");

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var a = new WeakMap();
  return _getRequireWildcardCache = function _getRequireWildcardCache() {
    return a;
  }, a;
}

function _interopRequireWildcard(a) {
  if (a && a.__esModule) return a;
  if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
    "default": a
  };

  var b = _getRequireWildcardCache();

  if (b && b.has(a)) return b.get(a);
  var c = {},
      d = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var e in a) {
    if (Object.prototype.hasOwnProperty.call(a, e)) {
      var f = d ? Object.getOwnPropertyDescriptor(a, e) : null;
      f && (f.get || f.set) ? Object.defineProperty(c, e, f) : c[e] = a[e];
    }
  }

  return c["default"] = a, b && b.set(a, c), c;
}

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

function _objectWithoutProperties(a, b) {
  if (null == a) return {};

  var c,
      d,
      e = _objectWithoutPropertiesLoose(a, b);

  if (Object.getOwnPropertySymbols) {
    var f = Object.getOwnPropertySymbols(a);

    for (d = 0; d < f.length; d++) {
      c = f[d], !(0 <= b.indexOf(c)) && Object.prototype.propertyIsEnumerable.call(a, c) && (e[c] = a[c]);
    }
  }

  return e;
}

function _objectWithoutPropertiesLoose(a, b) {
  if (null == a) return {};
  var c,
      d,
      e = {},
      f = Object.keys(a);

  for (d = 0; d < f.length; d++) {
    c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
  }

  return e;
}

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var Panel = _antd.Collapse.Panel,
    InputSwitch = function InputSwitch(a) {
  var b = a.type,
      c = a.handleBlur,
      d = a.CustomRender,
      e = a.setFieldValue,
      f = a.name,
      g = a.setFieldTouched,
      h = function h(a) {
    return e(f, a);
  };

  return "textarea" === b ? _react["default"].createElement(_Inputs.TextArea, _extends({}, a, {
    onBlur: c,
    onChange: h
  })) : "text" === b || "password" === b || "number" === b ? _react["default"].createElement(_Inputs.Input, _extends({}, a, {
    onChange: h,
    onBlur: c
  })) : "simpleLabel" === b ? _react["default"].createElement(_Inputs.SimpleLabel, a) : "checkbox" === b ? _react["default"].createElement(_Inputs.CheckboxGroup, _extends({}, a, {
    onChange: h,
    onBlur: c
  })) : "radio" === b ? _react["default"].createElement(_Inputs.RadioGroup, _extends({}, a, {
    onChange: function onChange(a) {
      h(a), g(f, !0);
    }
  })) : "select" === b ? _react["default"].createElement(_Inputs.Select, _extends({}, a, {
    onChange: h,
    onBlur: function onBlur() {
      return g(f, !0);
    }
  })) : "cascader" === b ? _react["default"].createElement(_Inputs.Cascader, _extends({}, a, {
    onChange: h,
    onBlur: function onBlur() {
      return g(f, !0);
    }
  })) : "selectSuggestion" === b ? _react["default"].createElement(_Inputs.SelectSuggestion, _extends({}, a, {
    onBlur: c
  })) : "slider" === b ? _react["default"].createElement(_Inputs.Slider, _extends({}, a, {
    onChange: h,
    onBlur: c
  })) : "date" === b ? _react["default"].createElement(_Inputs.Datepicker, _extends({}, a, {
    onChange: h,
    onOpenChange: function onOpenChange(a) {
      return !a && g(f, !0);
    }
  })) : "repeater" === b ? _react["default"].createElement(Repeater, _extends({}, a, {
    onChange: h,
    onBlur: c
  })) : "custom" === b ? _react["default"].createElement(d, _extends({}, a, {
    onBlur: c
  })) : null;
},
    Repeater = function Repeater(a) {
  var b = a.name,
      c = a.repeatButtonLabel,
      d = void 0 === c ? "repeat" : c,
      e = a.values,
      f = a.items,
      g = _objectWithoutProperties(a, ["name", "repeatButtonLabel", "values", "items"]);

  return _react["default"].createElement(_formik.FieldArray, {
    name: b,
    render: function render(a) {
      return _react["default"].createElement(_react["default"].Fragment, null, e && e[b] && 0 < e[b].length && e[b].map(function (c, d) {
        return (// eslint-disable-next-line react/no-array-index-key
          _react["default"].createElement(S.Repeater, {
            key: d
          }, f.map(function (a) {
            var f = a.label,
                h = a.type,
                i = a.condition,
                j = c[a.name]; // TODO: vedi: theFieldHasBeenEvaluedWithAnItemsThatDoentExistAnymoreAmongTheUpdatedItems

            if (i && !i(c, e)) {
              if (j || "" === j) {
                var k = g.setValues;
                k((0, _immer["default"])(e, function (c) {
                  // eslint-disable-next-line no-param-reassign
                  delete c[b][d][a.name];
                }));
              }

              return null;
            }

            return _react["default"].createElement(S.FormGroup, {
              key: "".concat(b, ".").concat(f, ".").concat(a.name)
            }, _react["default"].createElement(_antd.Form.Item, {
              label: f
            }, _react["default"].createElement(InputSwitch, _extends({}, g, a, {
              name: "".concat(b, ".").concat(d, ".").concat(a.name),
              value: j,
              type: h,
              label: f
            }))));
          }), _react["default"].createElement(S.HandlerButtonsWrapper, null, _react["default"].createElement(_Button["default"], {
            icon: "up",
            size: "small",
            type: null,
            onClick: function onClick(b) {
              b.preventDefault(), a.move(d, d - 1);
            }
          }), _react["default"].createElement(_Button["default"], {
            icon: "down",
            size: "small",
            type: null,
            onClick: function onClick(b) {
              b.preventDefault(), a.move(d, d + 1);
            }
          }), _react["default"].createElement(_Button["default"], {
            icon: "delete",
            size: "small",
            type: "danger",
            onClick: function onClick(b) {
              b.preventDefault(), a.remove(d);
            }
          })))
        );
      }), _react["default"].createElement(S.RepeatButtonWrapper, null, _react["default"].createElement(_Button["default"], {
        icon: "plus",
        type: null,
        onClick: function onClick(b) {
          b.preventDefault();
          var c = f.reduce(function (a, b) {
            return _objectSpread({}, a, _defineProperty({}, b.name, ""));
          }, {});
          a.push(c);
        }
      }, d)));
    }
  });
},
    InputField = function InputField(a) {
  var b = a.values,
      c = a.name,
      d = a.condition,
      e = a.setValues,
      f = a.errors,
      g = a.touched,
      h = a.submitCount,
      i = a.type,
      j = a.InputWrapper,
      k = a.label,
      l = a.headerLabel,
      m = a.hidden,
      n = a.items,
      o = a.orientation,
      p = a.validationSchema;
  if ("divider" === i) return _react["default"].createElement(_antd.Divider, {
    style: {
      fontSize: "1.125rem",
      fontWeight: "400",
      textTransform: "uppercase",
      paddingTop: ".5rem",
      paddingBottom: ".5rem"
    },
    orientation: o
  }, k);

  if ("accordion" === i) {
    var w = n && 0 < n.length && (n.filter(function (a) {
      return a.condition;
    }).length !== n.length || n.find(function (a) {
      return a.condition(b);
    }));
    return _react["default"].createElement(S.FormGroup, {
      hasError: n.find(function (a) {
        return f[a.name] && (g[a.name] || 0 < h);
      }),
      hasSuccess: !n.find(function (a) {
        return f[a.name] && g[a.name];
      }) && 0 < h && w
    }, _react["default"].createElement(_antd.Form.Item, {
      label: k
    }, _react["default"].createElement(_antd.Collapse, {
      expandIcon: function expandIcon(a) {
        var b = a.isActive;
        return _react["default"].createElement(_antd.Icon, {
          type: b ? "minus" : "plus"
        });
      }
    }, _react["default"].createElement(Panel, {
      disabled: !w,
      header: l
    }, n.map(function (b) {
      return _react["default"].createElement(InputField, _extends({
        key: b.name
      }, a, b, {
        InputWrapper: j
      }));
    })))));
  }

  var q = b[c],
      r = n && "function" == typeof n && n(b),
      s = q && r && -1 === r.findIndex(function (a) {
    return a.value === q;
  });
  if (d && !d(b) || s) return (q || "" === q) && e((0, _immer["default"])(b, function (a) {
    delete a[c];
  })), null; // to do:
  // aggiungere validazione sul repeater

  var t = f[c] && (g[c] || 0 < h) && "repeater" !== i,
      u = j || _react["default"].Fragment,
      v = !f[c] && (g[c] || 0 < h) && "repeater" !== i;
  return _react["default"].createElement(S.FormGroup, {
    hidden: m
  }, _react["default"].createElement(u, j && {
    name: c
  }, _react["default"].createElement(_antd.Form.Item, {
    label: k,
    validateStatus: t && "error" || v && "success" || "",
    help: f[c],
    hasFeedback: !0,
    required: p && p.fields[c]
  }, _react["default"].createElement(InputSwitch, _extends({}, a, {
    error: t,
    success: v,
    value: q,
    items: r || n
  })))));
},
    _default = function _default(a) {
  var b = a.initialValues,
      c = a.validationSchema,
      d = a.onSubmit,
      e = a.layout,
      f = void 0 === e ? {} : e,
      g = a.inputs,
      h = void 0 === g ? [] : g,
      i = a.onInputSort,
      j = a.inlineSortWrapperStyle,
      k = a.InputWrapper,
      l = a.displayFormikState,
      m = a.submitLabel,
      n = void 0 === m ? "submit" : m,
      o = a.submitIcon,
      p = a.showSubmit,
      q = a.onChange;
  return _react["default"].createElement(_formik.Formik, {
    initialValues: b,
    validationSchema: c,
    onSubmit: d
  }, function (a) {
    var b = a.isSubmitting,
        d = a.handleSubmit;
    return q && q(a), _react["default"].createElement(_antd.Form, _extends({}, f, {
      onSubmit: d
    }), i ? _react["default"].createElement(_Sortable["default"], {
      onChange: i,
      inlineSortWrapperStyle: j
    }, h.map(function (b) {
      return _react["default"].createElement(InputField, _extends({
        key: b.name
      }, b, {
        validationSchema: c
      }, a, {
        InputWrapper: k
      }));
    })) : h.map(function (b) {
      return _react["default"].createElement(InputField, _extends({
        key: b.name
      }, b, {
        validationSchema: c
      }, a, {
        InputWrapper: k
      }));
    }), l && _react["default"].createElement(S.FormikState, null, _react["default"].createElement("pre", null, JSON.stringify(a, null, 2))), (!(void 0 !== p) || p) && _react["default"].createElement(S.SubmitButtonWrapper, null, _react["default"].createElement(_Button["default"], {
      icon: o,
      loading: b,
      htmlType: "submit",
      disabled: b,
      onClick: d
    }, n)));
  });
};

exports["default"] = _default;